'use client';

import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import type { CareerOfferDestinationContext } from '../model/destination';
import { buildCareerOfferDestination } from '../model/destination';
import { useCareerOfferPromoTracking } from './use-career-offer-promo-tracking';

type Placement = Extract<
	NonNullable<CareerOfferDestinationContext['placement']>,
	'community_courses_menu' | 'community_footer' | 'problems_footer'
>;

export function CareerOfferTrackedLink({
	placement,
	entrypoint,
	className,
	children,
	onClick,
}: {
	placement: Placement;
	entrypoint: 'menu' | 'promo';
	className?: string;
	children: React.ReactNode;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}) {
	const searchParams = useSearchParams();
	const context = { placement, entrypoint, routing: 'direct' as const };
	const href = buildCareerOfferDestination(
		'/career-offer',
		new URLSearchParams(searchParams.toString()),
		context,
	);
	const tracking = useCareerOfferPromoTracking(context);

	return (
		<Link
			ref={tracking.ref}
			href={href}
			className={className}
			onClick={(event) => {
				tracking.onClick();
				onClick?.(event);
			}}
		>
			{children}
		</Link>
	);
}
